import { Language, useLanguage, useTheme } from '@infominds/react-native-components'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { DarkTheme, DefaultTheme, NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import React, { useEffect, useState } from 'react'
import { ColorSchemeName } from 'react-native'

import LoginScreen from '../screens/LoginScreen'
import { RootStackParamList } from '../types'
import BottomTabNavigator from './BottomTabNavigator'

const Stack = createStackNavigator<RootStackParamList>()

interface Props {
  isLoggedIn: boolean
}

export default function Navigation({ isLoggedIn }: Props) {
  const { colorScheme, updateColorScheme } = useTheme()
  const { setLanguageAsync } = useLanguage()

  const [oldLanguage, setOldLanguage] = useState<Language | undefined>(undefined)
  const [oldColor, setOldColor] = useState<NonNullable<ColorSchemeName> | undefined>(undefined)

  useEffect(() => {
    AsyncStorage.getItem('lang')
      .then(lng => {
        if (lng) {
          setOldLanguage(lng as Language)
        }
      })
      .catch(console.error)

    AsyncStorage.getItem('theme')
      .then(x => {
        if (x != null) {
          setOldColor(x as NonNullable<ColorSchemeName>)
        }
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (oldColor) {
      AsyncStorage.removeItem('theme').catch(console.error)
      updateColorScheme(oldColor)
    }
  }, [oldColor])

  useEffect(() => {
    if (oldLanguage) {
      AsyncStorage.removeItem('lang').catch(console.error)
      setLanguageAsync(oldLanguage).catch(console.error)
    }
  }, [oldLanguage])

  return (
    <NavigationContainer theme={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <Stack.Navigator initialRouteName="Login" screenOptions={{ headerShown: false }}>
        {!isLoggedIn ? <Stack.Screen name="Login" component={LoginScreen} /> : <Stack.Screen name="Root" component={BottomTabNavigator} />}
      </Stack.Navigator>
    </NavigationContainer>
  )
}
